
import FolderOpen from "../../../assets/duotone/FolderOpen.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FolderOpenIcon({ className, dataTestid = "FolderOpenIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FolderOpen data-testid={dataTestid} className={classes} {...rest} />
  );
}
